var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconToastSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 54 54",
    style: {
      enableBackground: "new 0 0 54 54"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.5,14.5l-29.9,30L19.1,48l-3.5-3.5l-14-14.1c-1.9-2-1.9-5.1,0-7.1c2-2,5.1-2,7.1,0L19,33.9L45.4,7.4 c2-2,5.1-2,7.1,0C54.5,9.4,54.5,12.5,52.5,14.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconToastSuccess);
export default __webpack_public_path__ + "static/media/icon-toast-success.6be0f5c1122902d39c2c07ef9c105e13.svg";
export { ForwardRef as ReactComponent };